import { forwardRef, type Ref, type SVGProps } from "react";

function SvgErrorBank(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <g clipPath="url(#error-bank_svg__a)">
        <circle
          cx={88}
          cy={60}
          r={50}
          fill="#fff"
          stroke="url(#error-bank_svg__b)"
          strokeWidth={20}
        />
        <path
          stroke="#82090F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M100.082 55.417V68.75m-6.667 0V55.417m-17.5 0V68.75m6.667 0V55.417M98.538 68.75H77.46a4.45 4.45 0 0 0-4.225 3.046 1.485 1.485 0 0 0 1.408 1.954h26.713a1.485 1.485 0 0 0 1.409-1.954 4.455 4.455 0 0 0-4.226-3.046m2.734-13.333H74.725a2.143 2.143 0 0 1-.966-4.056l11.985-6.055a5 5 0 0 1 4.51 0l11.985 6.055a2.144 2.144 0 0 1-.967 4.056"
        />
      </g>
      <rect width={30.712} height={30.712} x={36.394} y={14.644} fill="#B01921" rx={15.356} />
      <rect
        width={30.712}
        height={30.712}
        x={36.394}
        y={14.644}
        stroke="#fff"
        strokeWidth={0.787}
        rx={15.356}
      />
      <path
        fill="#fff"
        d="M51.018 35.125V33.58h1.545v1.545zm0-7.385v-2.75h1.531v2.75l-.354 4.62h-.808z"
      />
      <defs>
        <linearGradient
          id="error-bank_svg__b"
          x1={88}
          x2={87.57}
          y1={10}
          y2={85.533}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="error-bank_svg__a">
          <rect width={100} height={100} x={38} y={10} fill="#fff" rx={50} />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgErrorBank);
export default ForwardRef;
